export const JoinH5Routing = {
  path: "/joinh5",
  name: "joinh5",
  meta: { title: "激活密码" },
  component: () => import(/* webpackChunkName: "join" */ "@/views/join/h5/welcome/index.vue"),
  children: [],
};
